import { Link } from 'react-router-dom';
import { HStack } from '@chakra-ui/react';
import { Typography } from '@shinetools/sunshine-universal';

import * as Layout from 'layouts/ContentLayout';

import * as routes from '../../routes';

export const NewExportsHome = () => {
  return (
    <Layout.Root>
      <Layout.Body>
        <Typography.Text>Placeholder new exports home page</Typography.Text>

        <HStack>
          <Link to={routes.newExportOneOff}>Create one-off export</Link>

          <Link to={routes.newExportRecurring}>Create recurring export</Link>
        </HStack>
      </Layout.Body>
    </Layout.Root>
  );
};
